import React from "react";

function TitleTab({ title, index, indexNum }) {
  return (
    <>
      {/* Desktop */}
      <div
        className={`${
          index === indexNum
            ? "btn-solid btn-primary p-2"
            : "btn-solid bg-purple-200 text-purple-700 p-2"
        } hidden md:inline-block cursor-default rounded-b-none md:rounded-md text-base md:text-sm`}
      >
        {title}
      </div>
      {/* Mobile */}
      <div
        className={`${
          index === indexNum ? "block" : "hidden"
        } cursor-default btn-solid bg-purple-200 text-purple-700 rounded-b-none text-left font-semibold text-lg md:hidden`}
      >
        {title}
      </div>
    </>
  );
}

export default TitleTab;
